if (import.meta.env.PROD && !new URLSearchParams(window.location.search).get('debug')) {
    console.log = console.debug = console.info = () => {};
}
import React, { FC } from 'react';
import { MapRenderer, MapRendererProps } from '../components/MapRenderer';

/**
 * App component for instance mode rendering.
 * This is the entry point when using BalloonEventsMapInstance (JS API, Web Component).
 * 
 * It simply wraps MapRenderer - the shared rendering logic.
 * The separation exists because:
 * - BalloonEventsMapInstance.render() dynamically imports and renders this with createRoot()
 * - BalloonEventsMapComponent renders MapRenderer directly (inline, no createRoot)
 */
export interface AppProps extends MapRendererProps {}

const App: FC<AppProps> = (props) => {
    return <MapRenderer {...props} />;
};

export default App;
